module.exports = __webpack_public_path__ + "img/1-01.02aa9a11.png";